import React, { useState, useEffect } from 'react';
import '../styling/start.css';
import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';

export default function Start() {
    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const [name, setname] = useState('');
    const submitHandler = async (e) => {
        e.preventDefault();
        setloading(true);
        if (name !== "") {
            await axios.post("https://quiz-backend-mqz8.onrender.com/register", { name: name }).then(
                res => {
                    localStorage.setItem(`login_user_id`, `${res.data.userid}`);
                    localStorage.setItem(`login_user_name`, `${res.data.name}`);
                }
            );
        }
        else {
            alert("Fill your name first");
        }
        setloading(false);
        navigate('/create-quiz');
    }
    useEffect(() => {
        if (localStorage.getItem('user_exam_name')) {
            setname(localStorage.getItem('user_exam_name'));
        }
    }, []);
    if(loading) {
        return (
            <div className="loadanimation">
                Loading...
            </div>
        )
    }
    return (
        <>
            {localStorage.getItem("login_user_id") ? <Navigate to='/create-quiz' /> :
                <div className='start'>
                    <div className="stwap">
                        <div className="sthead">
                            <h2 className='homehead'>Test For Best Friends-BFF Quiz</h2>
                        </div>
                        <div className="inlab">write your name</div>
                        <div className='nameinput'>
                            <form className='nameform' onSubmit={submitHandler} >
                                <input className='name' type="text" value={name} onChange={(e) => setname(e.target.value)} required /> <br />
                                <input className='stbtn namesub' type="submit" value="Next" />
                            </form>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
